import { createContext } from 'react';

export const PageDataContext = createContext({
  getPageData: async () => [],
});


